import SettingQueueTaskTemplateTypeEnum from '../../../../../../projects/groups/data/enums/SettingQueueTaskTemplateTypeEnum';
import PageRequest from '../../../../../../pagination-helper/lib/PageRequest';

/**
 * * Модель запроса на получение списка шаблонов
 */
export default class GetTemplateListRequest  {
	/**
	 * * Тип
	 */
	Type?: SettingQueueTaskTemplateTypeEnum;
	/**
	 * * Поиск
	 */
	Search!: string;
	/**
	 * * Получить только те что создал текущий пользователь
	 */
	IsMine: boolean = false;
	/**
	 * * Пагинация
	 */
	Page!: PageRequest;
	constructor(obj?: Partial<GetTemplateListRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
